import { Col, Input, Row, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ScopeButton } from '../components/buttons';

export type QRCodeData = { code?: string; qrCodeImage?: string; secretKey?: string };

type QRCodeSetupProps = {
  QRCodeData?: QRCodeData;
  onVerifyCode: (code: string) => void;
};

export const QRCodeSetup = ({ QRCodeData, onVerifyCode }: QRCodeSetupProps) => {
  const { t } = useTranslation();
  const [mfaCode, setMfaCode] = useState('');
  const imageSrc = QRCodeData?.qrCodeImage || QRCodeData?.code;

  return (
    <Row justify="center" gutter={[0, 6]}>
      <Col span={24}>
        <Typography.Text>{t('account.mfa-setup-step-1')}</Typography.Text>
      </Col>
      <Col span={24}>
        <Typography.Text>
          {t('account.mfa-setup-step-2-before')}{' '}
          <strong>{t('account.mfa-setup-step-2-scan')}</strong>{' '}
          {t('account.mfa-setup-step-2-after')}
        </Typography.Text>
      </Col>
      <Col>{imageSrc && <img src={imageSrc} width={180} height={180} alt="" />}</Col>
      <Col span={24}>
        <Typography.Text>{t('account.mfa-setup-step-3')}</Typography.Text>
      </Col>
      <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
        <Input
          id="mfa-code"
          maxLength={6}
          size="large"
          style={{
            fontSize: 17,
            letterSpacing: 7,
            width: '65%',
            marginTop: 25,
            textAlign: 'center',
          }}
          onChange={(e) => setMfaCode(e.target.value.replace(/\D/g, ''))}
          value={mfaCode}
        />
      </Col>
      <Col span={24}>
        <div className="rows-drawer-footer">
          <ScopeButton
            type="primary"
            width="100%"
            onClick={() => {
              onVerifyCode(mfaCode);
              setMfaCode('');
            }}
          >
            {t('other.verify-code')}
          </ScopeButton>
        </div>
      </Col>
    </Row>
  );
};
